export const projectRolesConstants = {
    RETRIEVE_PROJECT_ROLES: 'RETRIEVE_PROJECT_ROLES',
  }
  